"use client";

import { useState } from "react";
import Image from "next/image";
import "./FeaturesSection.scss";
import { Container, Row, Col } from "react-bootstrap";
import { Tabs, Tab, Box } from "@mui/material";
import featuresImage from "@/assets/images/products/serviceconnect/Features.png";

export default function FeaturesSection() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  const sections = [
    {
      id: "requests",
      tab: "Requests",
      title: "Effortlessly manage every service ticket from start to finish.",
      description:
        "Create, assign, and track service requests in one place. Your team stays organized, and your customers stay informed—every step of the way.",
      image: featuresImage,
    },
    {
      id: "assignment",
      tab: "Assignment",
      title: "Assign the right job to the right technician—automatically",
      description:
        "With intelligent job allocation and smart scheduling, you save time and ensure every service call is handled by the best-suited technician based on location and skillset.",
      image: featuresImage,
    },
    {
      id: "tracking",
      tab: "Tracking",
      title: "Real-time visibility into field operations",
      description:
        "Monitor technician locations, track service progress live, and keep your customers updated instantly. No more guesswork—only transparency.",
      image: featuresImage,
    },
    {
      id: "customer-app",
      tab: "Customer App",
      title: "Empower your customers with self-service options",
      description:
        "From raising new service tickets to tracking progress and giving feedback—the customer app puts control in their hands and reduces support load for your team.",
      image: featuresImage,
    },
    {
      id: "amc",
      tab: "AMC",
      title: "Never miss a contract or warranty renewal again",
      description:
        "Keep track of all your AMC and warranty timelines. Get auto-reminders, manage renewals, and generate instant reports for better service continuity",
      image: featuresImage,
    },
  ];

  return (
    <section className="features-section" id="features">
      <Container>
        <div className="features-container">
          <h2 className="title">Core Features That Power Service Connect</h2>

          <Box>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              centered
              sx={{
                "& .MuiTabs-indicator": { display: "none" },
                minHeight: "80px",
              }}
              className="muti-tabs mt-5"
            >
              {sections.map((section) => (
                <Tab
                  key={section.id}
                  label={section.tab}
                  className="tabs-header"
                  sx={{ minHeight: "40px", height: "40px", fontSize: "16px" }}
                />
              ))}
            </Tabs>

            {sections.map((solution, index) => (
              <div key={solution.id} role="tabpanel" hidden={activeTab !== index}>
                {activeTab === index && (
                  <Row className="align-items-center justify-content-between main-container">
                    <Col xxl={7} xl={7} lg={7}>
                      <div className="content-container">
                        <h2>{solution.title}</h2>
                        <p>{solution.description}</p>
                      </div>
                    </Col>

                    <Col xxl={5} xl={5} lg={5} className="image-container">
                      <Image
                        src={solution.image}
                        alt={solution.title}
                        className="img-fluid"
                      />
                    </Col>
                  </Row>
                )}
              </div>
            ))}
          </Box>
        </div>
      </Container>
    </section>
  );
}
